import React, { useState } from "react";
import {
  ChevronDown,
  ChevronRight,
  CircleDollarSign,
  CreditCard,
  Gift,
  Monitor,
  Pencil,
  QrCode,
  Smartphone,
  Ticket,
  Wallet,
} from "lucide-react";

const paymentMethods = [
  {
    id: "upi",
    label: "Pay by any UPI App",
    icon: <span className="upi-logo">UPI</span>,
  },
  {
    id: "card",
    label: "Debit/Credit Card",
    icon: <CreditCard size={21} />,
  },
  {
    id: "wallet",
    label: "Mobile Wallets",
    icon: <Wallet size={21} />,
    className: "green-icon",
  },
  {
    id: "voucher",
    label: "Gift Voucher",
    icon: <Gift size={21} />,
    className: "pink-icon",
  },
  {
    id: "banking",
    label: "Net Banking",
    icon: <Monitor size={21} />,
  },
  {
    id: "later",
    label: "Pay Later",
    icon: <CircleDollarSign size={21} />,
    className: "gray-icon",
  },
  {
    id: "points",
    label: "Redeem Points",
    icon: <Ticket size={21} />,
    className: "orange-icon",
  },
];

const paymentContent = {
  upi: {
    title: "Pay by any UPI App",
    heading: "Scan QR code",
    description: "You need to have a registered UPI ID",
    icon: <QrCode size={28} />,
  },
  card: {
    title: "Debit/Credit Card",
    heading: "Pay using Card",
    description: "Enter your debit or credit card details",
    icon: <CreditCard size={28} />,
  },
  wallet: {
    title: "Mobile Wallets",
    heading: "Select Mobile Wallet",
    description: "Choose your preferred wallet to continue",
    icon: <Wallet size={28} />,
  },
  voucher: {
    title: "Gift Voucher",
    heading: "Redeem Gift Voucher",
    description: "Enter your voucher code and PIN",
    icon: <Gift size={28} />,
  },
  banking: {
    title: "Net Banking",
    heading: "Select your Bank",
    description: "Pay securely through your bank account",
    icon: <Monitor size={28} />,
  },
  later: {
    title: "Pay Later",
    heading: "Select Pay Later Option",
    description: "Choose an available pay later provider",
    icon: <CircleDollarSign size={28} />,
  },
  points: {
    title: "Redeem Points",
    heading: "Use Reward Points",
    description: "Redeem your available points for this booking",
    icon: <Ticket size={28} />,
  },
};

export default function PaymentPage() {
  const [activeMethod, setActiveMethod] = useState("upi");
  const selectedContent = paymentContent[activeMethod];

  return (
    <main className="payment-page">
      <div className="payment-layout">
        <section className="payment-panel">
          <header className="payment-panel-header">
            <h1>Payment options</h1>
          </header>

          <div className="payment-panel-body">
            <aside className="payment-sidebar">
              {paymentMethods.map((method) => (
                <button
                  type="button"
                  key={method.id}
                  className={`payment-method ${
                    activeMethod === method.id ? "active" : ""
                  }`}
                  onClick={() => setActiveMethod(method.id)}
                >
                  <span
                    className={`payment-method-icon ${
                      method.className || ""
                    }`}
                  >
                    {method.icon}
                  </span>

                  <span className="payment-method-label">{method.label}</span>
                </button>
              ))}
            </aside>

            <div className="payment-content">
              <h2>{selectedContent.title}</h2>

              <button type="button" className="payment-option-card">
                <span className="payment-option-icon">
                  {selectedContent.icon}
                </span>

                <span className="payment-option-text">
                  <strong>{selectedContent.heading}</strong>
                  <small>{selectedContent.description}</small>
                </span>

                <ChevronRight size={19} />
              </button>
            </div>
          </div>
        </section>

        <aside className="booking-summary">
          <section className="summary-card movie-card">
            <div className="movie-details">
              <div className="movie-heading">
                <div>
                  <h2>Dhamaal 4</h2>
                  <h3>Wed, 15 Jul, 2026 | 07:45 PM</h3>
                </div>

                <button type="button" className="edit-button">
                  <Pencil size={13} />
                  M-Ticket
                </button>
              </div>

              <p>Hindi (2D)</p>
              <p>SL-I10</p>
              <p>INOX: South City, Kolkata (IMAX 4)</p>
            </div>

            <div className="cancellation-box">
              <strong>Cancellation Available</strong>

              <p>
                This venue supports booking cancellation. To know more
              </p>

              <button type="button" className="text-link">
                view cancellation policy
              </button>
            </div>
          </section>

          <section className="summary-card price-card">
            <PriceRow label="Ticket(s) price" value="₹250.00" expandable />
            <PriceRow label="Convenience fees" value="₹46.02" expandable />
            <PriceRow label="Food & Beverage" value="₹445.00" expandable />

            <div className="donation-row">
              <div className="donation-content">
                <strong>Give to Underprivileged Musicians</strong>

                <span>
                  (₹1 per ticket)
                  <button type="button">VIEW T&amp;C</button>
                </span>
              </div>

              <div className="donation-price">
                <span>₹0.00</span>
                <button type="button">Add ₹1.00</button>
              </div>
            </div>

            <div className="order-total">
              <strong>Order total</strong>
              <strong>₹741.02</strong>
            </div>
          </section>

          <section className="summary-card contact-card">
            <div className="card-heading">
              <h3>For Sending Booking Details</h3>

              <button type="button" className="edit-button">
                <Pencil size={13} />
                Edit
              </button>
            </div>

            <p>+91-7980558688 | sayandeb998@gmail.com</p>
            <p>West Bengal (for GST purposes)</p>
          </section>

          <button type="button" className="summary-card offer-card">
            <span>
              <Gift size={18} />
              Apply Offers
            </span>

            <ChevronRight size={18} />
          </button>

          <section className="summary-card consent-card">
            By proceeding, I express my consent to complete this transaction.
          </section>

          <section className="summary-card payable-card">
            <span>Amount Payable</span>
            <strong>₹741.02</strong>
          </section>

          <button type="button" className="proceed-button">
            Proceed to Pay
          </button>
        </aside>
      </div>
    </main>
  );
}

function PriceRow({ label, value, expandable = false }) {
  return (
    <div className="price-row">
      <span className="price-label">
        {label}
        {expandable && <ChevronDown size={14} />}
      </span>

      <span>{value}</span>
    </div>
  );
}